var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-container"},[_c('div',{staticClass:"match-width"},[_c('title-bar',{staticClass:"title-bar",attrs:{"mini":this.mini}})],1),_c('post-media',{staticClass:"post-media"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }